import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Grid, Popover, TextField } from '@mui/material';
import PopupTitle from '../common/popup_title';
import DeleteCardConfirmPopover from '../common/delete_card_confirm_popover';

const SmorgStudioMembershipsChangeEmailPopup = ({
  anchorEl,
  title,
  onChangeEmail,
  onDismiss,
}) => {
  const [newEmail, setNewEmail] = useState(null);

  const [confirmationPopupAnchorEl, setConfirmationPopupAnchorEl] =
    useState(null);

  const isValid = newEmail && newEmail.includes('@') && newEmail.includes('.');

  return (
    <Popover
      open
      PaperProps={{
        style: { width: '320px', height: `180px`, padding: '10px' },
      }}
      onClose={onDismiss}
      anchorEl={anchorEl}>
      <Grid container>
        <Grid item xs={12}>
          <PopupTitle
            closeButtonEnabled
            onClickClose={onDismiss}
            titleText={title}
          />
        </Grid>
        <Grid item xs={12} style={{ padding: '10px 0' }}>
          Type new email for user:
        </Grid>
        <Grid item xs={12} style={{ padding: '10px 0' }}>
          <TextField
            variant="standard"
            fullWidth
            autoFocus
            value={newEmail}
            onChange={(ev) => setNewEmail(ev.target.value)}
          />
        </Grid>
        <Grid item xs={12} style={{ padding: '5px' }}>
          <Button
            onClick={(ev) => {
              ev.stopPropagation();
              setConfirmationPopupAnchorEl(ev.target);
            }}
            variant="contained"
            color="primary"
            size="medium"
            disableElevation
            disabled={!isValid}>
            Change email
          </Button>
        </Grid>
      </Grid>
      {confirmationPopupAnchorEl && (
        <DeleteCardConfirmPopover
          visible
          anchorEl={confirmationPopupAnchorEl}
          title="Change user email"
          message="The user's email will be permanently changed. Make sure you communicate the new email to the user. Are you sure you want to change this user's email?"
          height={200}
          width={360}
          onConfirmDelete={() => {
            onChangeEmail(newEmail);
            setConfirmationPopupAnchorEl(null);
          }}
          onDismiss={() => setConfirmationPopupAnchorEl(null)}
          actionButtonLabel="Change email"
        />
      )}
    </Popover>
  );
};

SmorgStudioMembershipsChangeEmailPopup.propTypes = {
  anchorEl: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
  onChangeEmail: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

export default SmorgStudioMembershipsChangeEmailPopup;
